import { Box, Button, Center, Divider, Heading, Text } from "@chakra-ui/react";
import ErrorText from "components/API/ErrorText";
import BoxShadowContainer from "components/UIComponents/BoxShadowContainer";
import { RequestMethod, RequestName } from "hooks/api/apiHookTypes";
import useApiRequest from "hooks/api/useApiHook";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import "./ProfileBalance.css";
import { useNavigate } from "react-router-dom";
import BalanceHistory from "./BalanceHistory";
import LoaderSpinner from "components/UIComponents/LoaderSpinner";

const ProfileBalance = () => {
  const key = useSelector((state: RootState) => state.apiKey.apiKey);

  const [balance, setBalance] = useState(null);

  const { data, loading, error } = useApiRequest(
    {
      apiToken: key,
      method: RequestMethod.GET,
      name: RequestName.GET_BALANCE,
    },
    60000
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (data?.data.balance) {
      setBalance(data.data.balance.toFixed(2));
    } else setBalance(0);
  }, [data]);

  return (
    <div className="profile-balance-block">
      {!loading && !error ? (
        <>
          <BoxShadowContainer className="profile-balance-wrapper">
            <Box>
              <Heading as="h2" size="md">
                <FormattedMessage id="ProfileBalanceText" />
              </Heading>
              <Text fontSize={18} mt={3}>
                {balance} $
              </Text>
            </Box>
            <div>
              <Divider
                height="100%"
                pt=".1px"
                width="1px"
                orientation="vertical"
              />
            </div>
            <Button
              onClick={() => navigate("/top-up-balance")}
              colorScheme="green"
            >
              Top up balance
            </Button>
          </BoxShadowContainer>
          <BalanceHistory />
        </>
      ) : error ? (
        <ErrorText />
      ) : (
        <Center>
          <LoaderSpinner />
        </Center>
      )}
    </div>
  );
};

export default ProfileBalance;
